import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { PulseLoader } from 'react-spinners'
import { usePrevious } from '../components/common/Helpers'
import Button from '../components/common/ui/buttons/Button'
import Input from '../components/common/ui/forms/Input'
import Notice from '../components/common/ui/Notice'

export default function SubscribeObituary({
    type,
    title,
    subtitle,
    description,
    store,
    service,
}) {

    const slice = useSelector(state => state[store + 'Reducer'])
    const loadingState = slice[store + 'CreateLoading']
    const errorState = slice[store + 'CreateError']

    const dispatch = useDispatch()
    const previous = usePrevious({ loadingState })
    const methods = useForm()

    const save = (data) => {
        dispatch(service.create({ ...data, ...{ type: type } }))
    }

    return (
        <div className="text-center tukios-subscribe-container">
            <div className="text-3xl mb-3 tukios-subscribe-title">
                {title}
            </div>

            {subtitle &&
                <div className="text-xl mb-3 uppercase tukios-subscribe-subtitle">
                    {subtitle}
                </div>
            }

            <div className="mb-3 leading-relaxed tukios-subscribe-description">
                {description}
            </div>

            {!loadingState && previous?.loadingState && errorState == null ? (
                <Notice type="success" description="Almost done! Please check your email for a link to confirm your subscription." className="tukios-subscribe-notice" />
            ) : (
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(save)} className="mt-6 mb-0 tukios-subscribe-form">
                        {!loadingState && errorState &&
                            <div className="my-2 text-red-600 tukios-subscribe-error">An error occured. Please try again.</div>
                        }
                        <div className="mb-6 text-gray-600 tukios-subscribe-input-container">
                            <Input name="email" placeholder="Email address" required={true} className="tukios-subscribe-input" />
                        </div>
                        <div>
                            {loadingState ? (
                                <PulseLoader color={"#ccc"} size={12} margin={10} />
                            ) : (
                                <Button label="Subscribe" type="submit" className="w-full tukios-subscribe-button" />
                            )}
                        </div>
                    </form>
                </FormProvider>
            )}
        </div>
    )
}